import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/quote-requests/excel-importer')({
    // Only redirects: `/parts/quote-requests/importer` checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    // The importer moved under the quote requests page that opens it, `/parts/quote-requests`; old links land here.
    beforeLoad: () => {
        throw redirect({ to: '/parts/quote-requests/importer', search: true, replace: true });
    },
});
